import {
  DETAILS_TRANSACTIONS_PREPAID_CHARGEBACK,
  DETAILS_TRANSACTIONS_PREPAID_CHARGEBACK_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const postTransactionsPrepaidChargeback = (params) => async (dispatch) => {
  const { descriptionTransaction, prepaid_transaction_id } = params || {};
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `api/prepaids/${prepaid_transaction_id}/chargeback`,
      {
        reason: descriptionTransaction,
      },
    );

    const { data, status } = response || {};

    dispatch({
      type: DETAILS_TRANSACTIONS_PREPAID_CHARGEBACK,
      payload: data || {},
      status: status || {},
      method: 'post',
    });
  } catch (e) {
    dispatch({
      type: DETAILS_TRANSACTIONS_PREPAID_CHARGEBACK_ERROR,
      payload: e || {},
    });
  }
};
